/* iceberg-ui */
import { Box, Flex, Text } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { useTheme } from '@mui/material/styles';

/* Hooks */
import { useUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  Images  */
import PictographFullSmileLineEyesCyanDark from 'images/pictograph/SVG/pictograph-fullSmile-lineEyes-cyan-dark.svg';
import PictographFullSmileLineEyesCyanLight from 'images/pictograph/SVG/pictograph-fullSmile-lineEyes-cyan-white.svg';

/*  React  */
import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { useTranslation } from 'react-i18next';

export const SuccessGraphic = ({ MotionWrapper, onConfettiComplete }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const userTheme = useUserTheme();
    const [recycle, setRecycle] = useState(true);

    const pictograph =
        userTheme === 'light'
            ? PictographFullSmileLineEyesCyanDark
            : PictographFullSmileLineEyesCyanLight;

    const colors = [
        theme.palette.confetti.color1,
        theme.palette.confetti.color2,
        theme.palette.confetti.color3,
        theme.palette.confetti.color4,
        theme.palette.confetti.color5,
        theme.palette.confetti.color6,
        theme.palette.confetti.color7,
        theme.palette.confetti.color8
    ];

    useEffect(() => {
        const timer = setTimeout(() => {
            setRecycle(false);
        }, 5000);
        return () => {
            clearTimeout(timer);
        };
    }, []);

    return (
        <>
            <Confetti
                colors={colors}
                recycle={recycle}
                numberOfPieces={1000}
                onConfettiComplete={onConfettiComplete}
            />
            <Flex
                alignItems="center"
                data-testid="onboardingSuccessStep"
                flexDirection="column"
                mb={4}
                mx="4%"
            >
                <Text
                    fontSize={['32px', '32px', '32px', 5]}
                    color={theme.palette.onboarding.titleTextColor}
                    fontWeight="600"
                    textAlign="center"
                    mt={5}
                    mb={4}
                >
                    {t('Onboarding.successStep.graphic.title')}
                </Text>
                <Box />
            </Flex>
            <Flex
                data-testid="onboardingSuccessStepImg"
                justifyContent="center"
                maxHeight="65%"
                width="100%"
            >
                <MotionWrapper key="onboardingSuccessStepMW">
                    <img
                        src={pictograph}
                        alt={t('Pictograph.fullSmileLineEyesCyanDark')}
                        width="320px"
                        data-testid="confettiImage"
                    />
                </MotionWrapper>
            </Flex>
        </>
    );
};
